import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '@/hooks/useFetch';

export interface HeatmapContact {
  id: number;
  firstName?: string;
  lastName?: string;
  address: {
    lat: number;
    lon: number;
    name: string;
  };
  activitiesCount: number;
  activities: Array<{
    operationId: string;
    operationName: string;
    source: string;
    category?: string;
    description?: string;
    createdAt: Date;
  }>;
}

export interface HeatmapData {
  contacts: HeatmapContact[];
}

const CRM_HEATMAP_URL = 'pvt/crm/contacts/heatmap';

export const useHeatmapData = () => {
  const [searchParams] = useSearchParams();
  const { data, loading, error, fetchData } = useFetch();
  const [heatmapData, setHeatmapData] = useState<HeatmapContact[]>([]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    // Remove pagination params as we want all contacts for heatmap
    params.delete('page');
    params.delete('rowsPerPage');
    params.delete('sortField');
    params.delete('sortDirection');
    params.delete('shaliachId');
    params.delete('operationsAllowed');
    params.delete('shaliachIdAllow');
    params.delete('startDate');
    params.delete('endDate');

    fetchData({
      url: `${CRM_HEATMAP_URL}?${params}`,
      method: 'GET'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.toString()]);

  useEffect(() => {
    if (data) {
      const heatmapResponse = data as HeatmapData;
      setHeatmapData(heatmapResponse.contacts || []);
    }
  }, [data]);

  return {
    heatmapData,
    loading,
    error
  };
};
